import React from 'react';
import { CTAButton } from './shared/CTAButton';
export function FinalClose() {
  return <section className="py-20 bg-[#1A1A2E] text-white text-center" data-id="element-46">
      <div className="max-w-4xl mx-auto px-4" data-id="element-47">
        <h2 className="text-3xl md:text-4xl font-serif mb-6" data-id="element-48">
          Si ya trabajás, no necesitás más motivación.
          <br data-id="element-49" />
          <span className="text-[#C9A96E]" data-id="element-50">
            Necesitás técnica que te dé consistencia.
          </span>
        </h2>

        <p className="text-xl text-gray-300 mb-10 leading-relaxed" data-id="element-51">
          Porque cuando tu terminación sube: tus fotos mejoran, tus clientas
          confían más, tu agenda se ordena y tus precios suben con seguridad.
        </p>

        <div className="bg-white/5 p-8 rounded-2xl border border-white/10 mb-12 backdrop-blur-sm" data-id="element-52">
          <p className="text-lg mb-6" data-id="element-53">
            Hoy podés entrar por{' '}
            <strong className="text-[#C9A96E]" data-id="element-54">$29 USD</strong>:
          </p>
          <p className="text-gray-300 mb-8" data-id="element-55">
            45 clases · 100% online · acceso de por vida + actualizaciones ·
            certificado avalado · grupo privado de Facebook · garantía 7 días.
          </p>

          <h3 className="text-2xl font-bold mb-8" data-id="element-56">
            ¿Cuánto te cuesta hoy tardar de más, retrabajar y no animarte a
            subir precios?
          </h3>

          <CTAButton text="SÍ, QUIERO ACCEDER POR $29 USD AHORA" className="w-full md:w-auto px-10 py-5 text-xl" data-id="element-57" />
        </div>

        <div className="text-sm text-gray-400 space-y-2" data-id="element-58">
          <p data-id="element-59">
            <strong data-id="element-60">P.D.</strong> El acceso es de por vida: lo comprás una vez y
            lo usás cada vez que quieras repasar.
          </p>
          <p data-id="element-61">
            <strong data-id="element-62">P.D.2</strong> Si tu meta es cobrar más, tu técnica tiene
            que sostenerlo. Empezá por acá.
          </p>
        </div>

        <footer className="mt-20 pt-10 border-t border-white/10 text-gray-500 text-xs" data-id="element-63">
          <p data-id="element-64">
            © {new Date().getFullYear()} Nails Artist Expert. Todos los
            derechos reservados.
          </p>
          <p className="mt-2" data-id="element-65">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          </p>
        </footer>
      </div>
    </section>;
}